// extracted by mini-css-extract-plugin
module.exports = {"root":"RejectionMessage_root__h8DIX","textarea":"RejectionMessage_textarea__3djgL"};